// Generate SEO-friendly URL for articles
export const generateArticleUrl = (article) => {
    if (!article) return '#';
    // Use slug if available, fallback to _id
    return `/article/${article.slug || article._id}`;
};

// Generate SEO-friendly URL for videos
export const generateVideoUrl = (video) => {
    if (!video) return '#';
    return `/video/${video.slug || video._id}`;
};

// Generate SEO-friendly URL for jokes
export const generateJokeUrl = (joke) => {
    if (!joke) return '#';
    return `/joke/${joke.slug || joke._id}`;
};

// Generate slug from title (for creating slugs)
export const createSlug = (title) => {
    if (!title) return '';
    return title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')      // Remove special characters
        .replace(/\s+/g, '-')               // Replace spaces with hyphens
        .replace(/-+/g, '-')                // Replace multiple hyphens with single
        .replace(/^-|-$/g, '');             // Remove hyphens from start/end
};